import { render } from "./PureLayout.vue?vue&type=template&id=0604228c&ts=true"
import script from "./PureLayout.vue?vue&type=script&lang=ts"
export * from "./PureLayout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__